function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#F4F5F9",
  d: "M81.356 22.576c0-7.16-5.858-13.017-13.017-13.017H13.017C5.857 9.56 0 15.417 0 22.576v55.322c0 7.16 5.858 13.017 13.017 13.017h55.322c7.16 0 13.017-5.857 13.017-13.017V22.576",
  transform: "translate(-147 -1111) translate(24 1089) translate(123 24)"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#001854",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3.254,
  d: "M67.45 60.24c0-1.207.98-2.186 2.187-2.186 1.208 0 2.187.98 2.187 2.187m3.255 0c0 .898-.73 1.627-1.628 1.627-.9 0-1.627-.729-1.627-1.627",
  transform: "translate(-147 -1111) translate(24 1089) translate(123 24)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M44.516 50.135c-7.907 0-14.968 2.528-19.628 6.492-.374.317-.925.249-1.205-.153-1.341-1.926-3.622-3.306-5.912-3.625-.52-.072-.968.379-.91.903l.601 5.412c.036.32-.127.623-.402.79-1.296.793-2.401 1.868-3.23 3.14-.91 1.398-2.413 2.295-4.079 2.295h-.873c-1.509 0-2.6 1.093-2.6 2.44v1.38c0 1.104.367 2.174 1.057 3.035 1.96 2.449 6.762 7.443 15.26 10.617.95.356 1.58 1.266 1.58 2.281v8.315c0 1.326 1.063 2.43 2.388 2.44 4.294.03 7.782-3.44 7.782-7.728v-1.792c0-.475.404-.844.877-.808 1.35.104 2.75.159 4.208.159h5.086c2.516 0 4.945-.257 7.24-.735 1.513-.314 2.93.84 2.93 2.385v6.079c0 1.326 1.06 2.43 2.385 2.44 4.294.03 7.783-3.44 7.783-7.728v-5.246c0-1.084.351-2.143 1.028-2.99 2.568-3.211 4.058-8.446 4.058-12 0-9.83-11.383-17.798-25.424-17.798z",
  transform: "translate(-147 -1111) translate(24 1089) translate(123 24)"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#001854",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3.254,
  d: "M44.516 50.135c-7.907 0-14.968 2.528-19.628 6.492-.374.317-.925.249-1.205-.153-1.341-1.926-3.622-3.306-5.912-3.625-.52-.072-.968.379-.91.903l.601 5.412c.036.32-.127.623-.402.79-1.296.793-2.401 1.868-3.23 3.14-.91 1.398-2.413 2.295-4.079 2.295h-.873c-1.509 0-2.6 1.093-2.6 2.44v1.38c0 1.104.367 2.174 1.057 3.035 1.96 2.449 6.762 7.443 15.26 10.617.95.356 1.58 1.266 1.58 2.281v8.315c0 1.326 1.063 2.43 2.388 2.44 4.294.03 7.782-3.44 7.782-7.728v-1.792c0-.475.404-.844.877-.808 1.35.104 2.75.159 4.208.159h5.086c2.516 0 4.945-.257 7.24-.735 1.513-.314 2.93.84 2.93 2.385v6.079c0 1.326 1.06 2.43 2.385 2.44 4.294.03 7.783-3.44 7.783-7.728v-5.246c0-1.084.351-2.143 1.028-2.99 2.568-3.211 4.058-8.446 4.058-12 0-9.83-11.383-17.798-25.424-17.798z",
  transform: "translate(-147 -1111) translate(24 1089) translate(123 24)"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#001854",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3.254,
  d: "M17.924 65.39c0 .225.183.407.407.407.225 0 .407-.182.407-.406 0-.225-.182-.407-.407-.407-.224 0-.407.182-.407.407zM37.601 58.168L51.43 58.168",
  transform: "translate(-147 -1111) translate(24 1089) translate(123 24)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D2D8E9",
  d: "M64.271 40.475c0-8.313-6.738-15.051-15.05-15.051-8.314 0-15.052 6.738-15.052 15.05 0 8.312 6.738 15.051 15.051 15.051 8.313 0 15.051-6.74 15.051-15.05",
  transform: "translate(-147 -1111) translate(24 1089) translate(123 24)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D2D8E9",
  d: "M59.39 40.475c0-5.617-4.553-10.17-10.17-10.17-5.616 0-10.17 4.553-10.17 10.17 0 5.615 4.554 10.17 10.17 10.17 5.617 0 10.17-4.555 10.17-10.17z",
  transform: "translate(-147 -1111) translate(24 1089) translate(123 24)"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#001854",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3.254,
  d: "M59.39 40.475c0-5.617-4.553-10.17-10.17-10.17-5.616 0-10.17 4.553-10.17 10.17 0 5.615 4.554 10.17 10.17 10.17 5.617 0 10.17-4.555 10.17-10.17z",
  transform: "translate(-147 -1111) translate(24 1089) translate(123 24)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D2D8E9",
  d: "M39.05 25.22c0-2.808-2.275-5.084-5.084-5.084-2.808 0-5.085 2.276-5.085 5.084 0 2.807 2.277 5.085 5.085 5.085 2.809 0 5.085-2.278 5.085-5.085z",
  transform: "translate(-147 -1111) translate(24 1089) translate(123 24)"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#001854",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3.254,
  d: "M39.05 25.22c0-2.808-2.275-5.084-5.084-5.084-2.808 0-5.085 2.276-5.085 5.084 0 2.807 2.277 5.085 5.085 5.085 2.809 0 5.085-2.278 5.085-5.085z",
  transform: "translate(-147 -1111) translate(24 1089) translate(123 24)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D2D8E9",
  d: "M54.305 15.05c0-2.808-2.276-5.084-5.085-5.084-2.808 0-5.084 2.276-5.084 5.085 0 2.807 2.276 5.085 5.084 5.085 2.809 0 5.085-2.278 5.085-5.085z",
  transform: "translate(-147 -1111) translate(24 1089) translate(123 24)"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#001854",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3.254,
  d: "M54.305 15.05c0-2.808-2.276-5.084-5.085-5.084-2.808 0-5.084 2.276-5.084 5.085 0 2.807 2.276 5.085 5.084 5.085 2.809 0 5.085-2.278 5.085-5.085zM59.39 40.475V22.169M52.88 37.22V27.05m-24-1.83v-8.542m25.424-8.95v-3.66m-20.339 11.39v-5.289M49.22 8.542V0M20.06 38.708l-4.602-4.604m0 4.604l4.601-4.604m53.392-1.375l-3.254-3.254m0 3.254l3.254-3.254",
  transform: "translate(-147 -1111) translate(24 1089) translate(123 24)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#001854",
  d: "M8.694 30.595c0 .9-.73 1.627-1.627 1.627-.899 0-1.628-.727-1.628-1.627 0-.898.73-1.627 1.628-1.627.898 0 1.627.729 1.627 1.627",
  transform: "translate(-147 -1111) translate(24 1089) translate(123 24)"
})))));

var SvgIcZarabiaj = function SvgIcZarabiaj(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 100,
    viewBox: "0 0 82 100",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcZarabiaj, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic-zarabiaj.7be24258.svg";
export { ForwardRef as ReactComponent };